module.exports = __webpack_public_path__ + "media/images/pages/inspire_with_computing_ambassador/inspire_your_students-5df3cccfcc31e00d605799e8a1557fb6.png";